import { NgFor } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { LmsModalFrameComponent } from '@lmsSharedUI';

@Component({
  selector: 'app-risk-matrix-score',
  standalone: true,
  template: `
    <app-lms-modal-frame [title]="'Risk Analysis'" [pageHeadWidth]="500">
    <div modal-body>
      <div class="container-fluid">
        <div class="card">
          <div class="card-body p-1">
            <table w450 class="table table-bordered table-striped table-sm shadow-2-strong rounded-1 p-1">
              <thead>
                <tr class="table-center-header">
                  <th>Risk Type</th>
                  <th>Risk Score</th>
                </tr>
              </thead>
              <tbody>
                <!--  *ngIf="clientResults.loans"> -->
                <tr *ngFor="let risk of riskAnalysis">
                  <td class="ps-3 font-weight-bold" style="width: 70%;">{{ risk.riskType }}</td>
                  <td class="text-center muted-text mbr-price-figure" style="width: 25%; font-size: 105%;">{{ risk.riskValue }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div modal-actions class="flex-container">
      <button type="button" class="btn btn-primary" mdbRipple (click)="close()">Close</button>
    </div>
    </app-lms-modal-frame>
  `,
  imports: [NgFor, LmsModalFrameComponent],
  styleUrls: ['./risk-matrix-score.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class RiskMatrixScoreComponent {
  riskAnalysis: any;

  constructor(public modalRef: MdbModalRef<RiskMatrixScoreComponent>) {}

  close() {
    this.modalRef.close();
  }
}
